import { Component, HostListener, Input, OnChanges, Output, ViewChild, EventEmitter , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { State } from '@app/core/ngrx/reducers';
import { userSelectors } from '@app/core/ngrx/selectors';
import { ApplicationService } from '@app/core/services/application/application.service';
import { SendEventActionsService } from '@app/core/services/events/sendEventActions.service';
import { ModalService } from '@app/core/services/modal/modal.service';
import { ProgramService } from '@app/core/services/program/program.service';
import { WarningService } from '@app/core/services/warning/warning.service';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { IonSlides, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Angulartics2GoogleTagManager } from 'angulartics2';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';
import { NumberToWordsPipe } from '@app/shared/pipes/numberToWords/number-to-words.pipe';

@Component({
    selector: 'app-program-bundle-parent',
    templateUrl: './program-bundle-parent.component.html',
    styleUrls: ['./program-bundle-parent.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, ImgPipe, NumberToWordsPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramBundleParentComponent implements OnChanges {
    @Input() details: any;
    @ViewChild('mySlider') slides: IonSlides;

    USER_ID$ = this.store.select(userSelectors.getUserID);
    USER_ID: string; //

    USER_EMAIL$ = this.store.select(userSelectors.getUserEmail);
    USER_EMAIL: string; //

    slideOpts = {
        slidesPerView: 3,
        initialSlide: 0,
        speed: 400,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        allowSlideNext: true,
        allowSlidePrev: true,
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 1,
                spaceBetween: 40,
            },
            // // when window width is >= 480px
            // 480: {
            //     slidesPerView: 1,
            //     spaceBetween: 40
            // },
            // // when window width is >= 640px
            // 640: {
            //     slidesPerView: 1,
            //     spaceBetween: 40
            // },
            992: {
                slidesPerView: 1,
                spaceBetween: 40,
            },
            1390: {
                slidesPerView: 2,
                spaceBetween: 40,
            },
        },
    };

    faChevronRight = faChevronRight;
    faChevronLeft = faChevronLeft;

    selectedProgram: any = {};

    testData: any[] = [];

    rightIndex: number = 0;
    leftIndex: number;

    bundledApplyProgram: any[] = [];

    innerWidth: any;

    bundleSubmitted: boolean = false;

    totalBundleAmount: number = 0;
    totalDiscount: number;

    couponTwoDiscount = 0;
    couponThreeDiscount = 0;

    dirtyFormFound: any[] = [];

    noDiscountDescription: boolean = false;

    sliderPositionState: string = '';

    constructor(
        private formBuilder: FormBuilder,
        private applicationService: ApplicationService,
        private store: Store<State>,
        private modalService: ModalService,
        private warning: WarningService,
        private navCtrl: NavController,
        private programService: ProgramService,
        private sendEventActionsService: SendEventActionsService,
        private angulartics2GoogleTagManager: Angulartics2GoogleTagManager
    ) {
        this.USER_ID$.subscribe((id) => {
            this.USER_ID = id;
        });
        this.USER_EMAIL$.subscribe((id) => {
            this.USER_EMAIL = id;
        });

        this.selectedProgramEvent();
        this.sliderPositionState = 'start';
    }

    ngOnChanges() {
        if (this.details.programs && this.details.programs.length) {
            this.details.programs.forEach((p) => {
                this.totalBundleAmount = this.totalBundleAmount + p.price;
                const random = newId();
                const programCopy = { ...p, objectId: random };
                this.testData.push(programCopy);
            });

            this.noDiscountDescription = this.details.bundleDiscounts.length > 0 ? false : true;

            this.leftIndex = this.testData.length;
            if (window.matchMedia('(max-device-width: 960px)').matches) {
                this.programSelected(this.testData[0], 0, true);
            } else {
                this.programSelected(this.testData[1], 1, false);
            }
            if (this.details.bundleDiscounts.length) {
                this.details.bundleDiscounts.forEach((a) => {
                    if (a.count === 2) {
                        this.couponTwoDiscount = a.discount;
                    }
                    if (a.count === 3) {
                        this.couponThreeDiscount = a.discount;
                    }
                });
            }
        }
    }

    slideChanged(slides: IonSlides) {
        this.sliderPositionState = '';
        this.slides.isBeginning().then((isBegining) => {
            if (isBegining == true) {
                this.sliderPositionState = 'start';
            }
        });
        this.slides.isEnd().then((isEnd) => {
            if (isEnd == true) {
                this.sliderPositionState = 'end';
            }
        });
        //console.log(this.sliderPositionState);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
        if (this.innerWidth < 1250) {
            this.programSelected(this.testData[0], 0, true);
        } else {
            this.programSelected(this.testData[1], 1, false);
        }
    }

    rightClick() {
        this.slides.slideNext();
    }

    leftClick() {
        this.slides.slidePrev();
    }

    programSelected(program: any, index: number, mobile?: boolean) {
        this.selectedProgram = program;
        this.programService.setSelectedProgramBundleIdSubject.next(program.id);
        this.programService.setUserEmailSubject.next(this.USER_EMAIL);
    }

    // custom function for bundle selection validation
    // i know i know its dirty
    gettingInvalidMarker(event: any) {
        if (this.dirtyFormFound.some((a) => a.programid === event.programid)) {
            this.dirtyFormFound.forEach((a) => {
                if (a.programid === event.programid) {
                    const index = this.dirtyFormFound.indexOf(a);
                    this.dirtyFormFound.splice(index, 1);
                    if (event.selected) {
                        this.dirtyFormFound.push(event);
                    }
                }
            });
        } else {
            this.dirtyFormFound.push(event);
        }
    }

    submit() {
        return;
        if (this.dirtyFormFound.some((a) => !a.valid)) {
            this.warning.create('Please select both start date and type.');
            return;
        } else {
            this.bundleSubmitted = true;
            this.applicationService
                .newItinerary({
                    userid: this.USER_ID,
                    selections: this.bundledApplyProgram,
                    bundleid: this.details.programid,
                })
                .subscribe(
                    (response: any) => {
                        if (response.success === true) {
                            this.bundleSubmitted = false;
                            let applicationChainId = response.applicationChain.applicationChain.id;

                            this.sendEventActionsService.sendEventActions({
                                pageview: '/application-chain-bundle-created',
                                eventAction: 'applicationChainBundleCreated',
                                eventCategory: 'Itinerary',
                                ddAction: 'applicationChainBundleCreated',
                                customDimensions: {
                                    cdEmail: this.USER_EMAIL$,
                                    cdChainLength: this.bundledApplyProgram.length,
                                },
                            });
                            this.modalService
                                .successfulAction({
                                    message: 'Applications Created!',
                                    submessage: 'Follow Next Step to continue your application process.',
                                })
                                .then((res: any) => {
                                    setTimeout(() => {
                                        this.navCtrl.navigateRoot(['/application-chain/' + applicationChainId]);
                                    }, 300);
                                })
                                .catch((error: Error) => {
                                    setTimeout(() => {
                                        this.navCtrl.navigateRoot(['/application-chain/' + applicationChainId]);
                                    }, 300);
                                });
                        }
                    },
                    (err: any) => {
                        console.log('err', err);
                        this.bundleSubmitted = false;

                        //error trace block start
                        this.angulartics2GoogleTagManager.eventTrack('program bundle apply click', {
                            category: 'Program bundle',
                            label: 'Error: ' + err,
                        });

                        this.sendEventActionsService.sendEventActions({
                            eventAction: 'program bundle apply Error',
                            eventCategory: 'Program bundle',
                            ddAction: 'progarmBundleApply',
                            customDimensions: {
                                userid: this.USER_ID,
                                selections: this.bundledApplyProgram,
                                bundleid: this.details.programid,
                            },
                            ddContext: {
                                tracer: 'program bundle apply',
                                err: err,
                            },
                        });
                        //error trace block end

                        if (err.error) {
                            const errObject = err.error;
                            if (errObject.errorLog) {
                                this.warning.create(errObject.errorLog[0].message);
                            } else if (errObject.message) {
                                this.warning.create(errObject.message);
                            } else {
                                this.warning.create(errObject.errors[0].message);
                            }
                        }
                    }
                );
        }
    }

    public onFormGroupChangeEvent(_event) {
        const dates = _event['start'].startdate;
        const splitDates = dates.split('-');
        const type = _event['type'];
        const array = new Uint16Array(4);
        const windowUUID = window.crypto.getRandomValues(array);

        const selection = {
            int_id: windowUUID[0].toString(),
            programid: _event.programid,
            programname: _event.name,
            location: _event.city + ', ' + _event.state,
            startdate: _event['start'].startdate,
            enddate: _event['start'].enddate,
            price: _event['start'].price,
            month: splitDates[0],
            startyear: splitDates[2],
            userid: this.details.profile.id,
            type: type,
            saved_selected_date: {
                ..._event['start'],
            },
        };

        if (!_event.selected) {
            const index = this.bundledApplyProgram.findIndex((a) => a.programid === _event.programid);

            this.bundledApplyProgram.splice(index, 1);
        } else if (this.bundledApplyProgram.every((a) => a.programid !== selection.programid)) {
            this.bundledApplyProgram.push(selection);
        } else {
            this.bundledApplyProgram.forEach((a) => {
                if (a.programid === selection.programid) {
                    const index = this.bundledApplyProgram.indexOf(a);
                    this.bundledApplyProgram.splice(index, 1);
                    this.bundledApplyProgram.push(selection);
                }
            });
        }

        for (let bundleTier of this.details.bundleDiscounts) {
            if (this.bundledApplyProgram.length <= 1) {
                this.totalDiscount = null;
            } else if (this.bundledApplyProgram.length === bundleTier.count) {
                this.totalDiscount = bundleTier['discount'];
            }
        }
    }

    selectedProgramEvent() {
        this.programService.getSelectedProgramBundleIdSubject().subscribe((id: string) => {
            const program = [...this.testData].filter((a) => {
                return a.id === id;
            });
            this.selectedProgram = program[0];
        });
    }
}

const newId = () => {
    const random = Math.random();
    return random;
};
